import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect } from 'react';
import { useEntryFormContext } from 'context/EntryFormContext';
import { deleteEmptyArrayValues } from 'helpers/deleteEmptyArrayValues';
import { SERVICE_TYPES } from 'constants/serviceTypes';
import { TabSelector } from 'components/TabSelector';
import styles from 'pages/Schedule/CreateEntry/CreateEntry.scss';

const ENTRY_TYPES = ['Заняття', 'Група', 'Оренда'];

export const EntryTypeSelector = () => {
  const { form, entryTypeIndex, setEntryTypeIndex, isEditing } = useEntryFormContext();

  useEffect(() => {
    if (!isEditing) {
      form.setFieldValue('group', '');

      const updatedClients = form.values.clients.map((client) => ({
        ...client,
        locked: false,
      }));
      form.setFieldValue('clients', updatedClients);

      if (entryTypeIndex === 0) {
        const firstCoach = form.values.coaches[0] || { coach: '', price: '' };
        form.setFieldValue('coaches', [firstCoach]);
      } else {
        const service = entryTypeIndex === 1 ? SERVICE_TYPES.GROUP : SERVICE_TYPES.RENT;
        form.setFieldValue('service', service);
      }
    }
  }, [entryTypeIndex, isEditing]);

  useEffect(() => {
    if (entryTypeIndex >= 1 || isEditing) return;

    const cleanedCoaches = deleteEmptyArrayValues(form.values.coaches.map(({ coach }) => coach));

    const service = cleanedCoaches.length ? SERVICE_TYPES.LESSON : SERVICE_TYPES.TRAINING;

    form.setFieldValue('service', service);
  }, [form.values.coaches, entryTypeIndex, isEditing]);

  return (
    <>
      <span className={styles.fieldName}>
        <FontAwesomeIcon icon={faInfoCircle} />
        Тип запису
      </span>
      <TabSelector tabs={ENTRY_TYPES} onTabChange={setEntryTypeIndex} defaultActiveIndex={entryTypeIndex} />
    </>
  );
};
